<div *ngIf="loading" class="loading-text">
    <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
  </div>

<div *ngIf="!loading">
<app-sub-header [pageTitle]="'Cars' | translate"></app-sub-header>

<div class="padded-container">
    <!-- Search input added -->
    <dx-text-box
      *ngIf="carListResponse?.cars?.length"
      [(ngModel)]="searchText"
      [showClearButton]="true"
      [valueChangeEvent]="'input'"
      placeholder="{{ 'SearchCar' | translate }}"
      class="full-width-button"
      style="margin-bottom: 10px;"
    ></dx-text-box>

    <dx-accordion [collapsible]="true" [multiple]="true" (onContentReady)="onContentReady($event)">
        <dxi-item title="{{ 'CarsInService' | translate }}" [expanded]="true">
            <div *ngIf="filteredInServiceCars.length; else noInServiceCars">
                <div *ngFor="let carItem of filteredInServiceCars">
                    <dx-button class="full-width-button" type="default" (onClick)="continueNextStep(carItem.id ?? 0, carItem.number, carItem.servVoucherId ?? 0)" [text]="carItem.number + ' - ' + carItem.driverReserved">
                    </dx-button>
                </div>
            </div>
            <ng-template #noInServiceCars>
                <span>{{ 'NoCars' | translate }}</span>
            </ng-template>
        </dxi-item>
        
        <dxi-item title="{{ 'AvailableCars' | translate }}" [expanded]="true">
            <div *ngIf="filteredAvailableCars.length; else noAvailableCars">
                <div *ngFor="let carItem of filteredAvailableCars">
                    <dx-button class="full-width-button" type="default" (onClick)="continueNextStep(carItem.id ?? 0, carItem.description, null)" [text]="carItem.number">
                    </dx-button>
                </div>
            </div>
            <ng-template #noAvailableCars>
                <span>{{ 'NoCars' | translate }}</span>
            </ng-template>
        </dxi-item>
    </dx-accordion>
    
    <dx-button class="full-width-button" type="danger" (onClick)="navigateToService()" text="{{ 'Back' | translate }}"></dx-button>
</div>
</div>